/* ═══════════════════════════════════════════════════════════════════
   DG Store Status — Open/Closed indicator (Eastern Time)
   Distribution Gauthier | ThemeDGCore
   ═══════════════════════════════════════════════════════════════════
   Business hours:
     Mon-Mer : 7h00 – 16h30
     Jeu-Ven : 7h00 – 17h30
     Sam-Dim : Fermé
   ═══════════════════════════════════════════════════════════════════ */
(function () {
    'use strict';

    var statusEl = document.getElementById('dg-store-status');
    var labelEl = document.getElementById('dg-status-label');
    var detailEl = document.getElementById('dg-status-detail');
    if (!statusEl || !labelEl || !detailEl) return;

    /* Schedule: [dayOfWeek] = { open: hour*100+min, close: hour*100+min }
       dayOfWeek: 0=Sun … 6=Sat  */
    var SCHEDULE = {
        1: { open: 700, close: 1630 },  /* Lundi    */
        2: { open: 700, close: 1630 },  /* Mardi    */
        3: { open: 700, close: 1630 },  /* Mercredi */
        4: { open: 700, close: 1730 },  /* Jeudi    */
        5: { open: 700, close: 1730 }   /* Vendredi */
    };

    var DAY_NAMES = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

    function formatTime(hhmm) {
        var h = Math.floor(hhmm / 100);
        var m = hhmm % 100;
        return h + 'h' + (m > 0 ? (m < 10 ? '0' : '') + m : '');
    }

    function getNextOpenDay(currentDay) {
        /* Find the next weekday with hours */
        for (var i = 1; i <= 7; i++) {
            var d = (currentDay + i) % 7;
            if (SCHEDULE[d]) return { day: d, hours: SCHEDULE[d] };
        }
        return null;
    }

    function update() {
        /* Get current time in Eastern timezone */
        var now = new Date();
        var eastern = new Date(now.toLocaleString('en-US', { timeZone: 'America/Toronto' }));
        var day = eastern.getDay();
        var timeNum = eastern.getHours() * 100 + eastern.getMinutes();

        var sched = SCHEDULE[day];

        if (sched && timeNum >= sched.open && timeNum < sched.close) {
            /* ── OPEN ── */
            statusEl.classList.remove('is-closed');
            statusEl.classList.add('is-open');
            labelEl.textContent = 'Magasin ouvert';
            detailEl.textContent = 'ferme à ' + formatTime(sched.close);
        } else {
            /* ── CLOSED ── */
            statusEl.classList.remove('is-open');
            statusEl.classList.add('is-closed');
            labelEl.textContent = 'Magasin fermé';

            /* Figure out when we open next */
            if (sched && timeNum < sched.open) {
                /* Today but not yet open */
                detailEl.textContent = 'ouvre à ' + formatTime(sched.open);
            } else {
                /* After hours or weekend */
                var next = getNextOpenDay(day);
                if (next) {
                    if (next.day === (day + 1) % 7) {
                        detailEl.textContent = 'ouvre demain à ' + formatTime(next.hours.open);
                    } else {
                        detailEl.textContent = 'ouvre ' + DAY_NAMES[next.day] + ' à ' + formatTime(next.hours.open);
                    }
                }
            }
        }
    }

    /* Run immediately + refresh every 60 seconds */
    update();
    setInterval(update, 60000);
})();
